import { render, staticRenderFns } from "./UpdateIdentifiers.vue?vue&type=template&id=271f70e3"
import script from "./UpdateIdentifiers.vue?vue&type=script&lang=js"
export * from "./UpdateIdentifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports